__turbopack_context__.v({
  "emptyList": "CardsList-module-scss-module__Sr59Hq__emptyList",
  "groupHeaderCard": "CardsList-module-scss-module__Sr59Hq__groupHeaderCard",
});
